import { useEffect } from 'react'
import ShortcutManager from 'Services/ShortcutManager'

export default (hotKeyConfigs) ->

  hotKeyConfigs.map(({
    sequence, # key sequence to bind to
    fn, # function to be triggered
    temporary, # whether this should replace and existing shortcut for it's lifespan, or not
    expr, # an expression which activates/deactivates the shortcut depending on the truthiness of the expression
    watchers # list of variables which indicate that either `expr` or `fn` should be re-evaluated
  }) ->
    useEffect( ->
      if (expr ?= true)
        cleanup = ShortcutManager.register(sequence, fn, temporary)
      else
        cleanup?()
      ->
        cleanup?()
    , [watchers ?= []...])
  )